import React, { useState } from "react";
import { GoX } from "react-icons/go";
import { RiArrowLeftWideFill } from "react-icons/ri";
import {
  DISPLAY_HEADER_ICON_BACK,
  DISPLAY_HEADER_ICON_CLOSE,
} from "../../constants/common_constants";
import { HiBars3 } from "react-icons/hi2";
import { useTranslation } from "react-i18next";

interface HeaderProps {
  title: string;
  displayheaderIcon: number;
  displayheaderMenuIcon?: boolean;
  onBtnClick?: () => void;
  onMenuBtnClick?: () => void;
}

export const GeneralCommonHeader: React.FC<HeaderProps> = ({
  title,
  displayheaderIcon,
  displayheaderMenuIcon,
  onBtnClick,
  onMenuBtnClick,
}) => {
  //ハンバーガーメニューの展開状態を格納
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const { t } = useTranslation();
  // propsによって戻るボタンの種類や有無を変化させる処理
  const displayIcon = () => {
    if (displayheaderIcon === DISPLAY_HEADER_ICON_BACK) {
      return (
        <button
          type="button"
          id="btnBack"
          className="text-center flex justify-center items-center text-white text-[14px]"
          onClick={onBtnClick}
        >
          <RiArrowLeftWideFill className="h-10 w-8 text-white flex" />
          <p className="-ml-2 truncate max-w-[32px]">{t("ヘッダー.戻る")}</p>
        </button>
      );
    } else if (displayheaderIcon === DISPLAY_HEADER_ICON_CLOSE) {
      return (
        <button
          type="button"
          id="btnClose"
          className="text-xl text-center p-4 "
          onClick={onBtnClick}
        >
          <GoX className="h-8 w-6 text-white" />
        </button>
      );
    }
  };
  //メニューボタンをレンダリング
  const MenuIcon = () => {
    return (
      <button
        type="button"
        id="btnMenu"
        className="text-xl text-center p-4"
        onClick={handleOnMenuButton}
      >
        {menuOpen ? (
          <GoX className="h-8 w-6 text-white" />
        ) : (
          <HiBars3 className="h-8 w-6 text-white" />
        )}
      </button>
    );
  };
  //メニューボタンがクリックされた際の処理
  const handleOnMenuButton = () => {
    setMenuOpen((prevState) => !prevState);
    if (onMenuBtnClick) onMenuBtnClick();
  };

  //共通ヘッダー部分
  return (
    <div className="sticky top-0 w-full">
      <header className="flex items-center justify-between bg-main-red h-16">
        <div className="flex-shrink-0 w-[57px]">
          {/* 左上の領域に表示するアイコン */}
          {displayIcon()}
        </div>
        {/* タイトル表示 */}
        <div className="flex-grow text-center text-white text-[22px] font-bold truncate">
          {title}
        </div>
        <div className="flex-shrink-0 w-[57px]">
          {/* 右上の領域に表示するアイコン */}
          {displayheaderMenuIcon && MenuIcon()}
        </div>
      </header>
    </div>
  );
};
